import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
export function hasPreset(config: ResolvedBetterstartConfig, presetId: string): boolean {
  return config.presets.installed.includes(presetId)
}
